import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService} from './../services/authentication.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {environment} from "../../../environments/environment";

export const HANDLE_HTTP_ERROR_LOCALLY = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private snackBar: MatSnackBar, private authenticationService: AuthenticationService, private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(catchError(err => {
            if(request.context.get(HANDLE_HTTP_ERROR_LOCALLY)) {
              return throwError(err);
            }

          // auto logout if 401 response returned from api
            if (err.status === 401 || err.status === 403) {
              // console.log('Unauthorized or Forbidden request:', err);
              // console.log(err);
              // if(environment.isLocal) {
              //   this.router.navigate(['/error-401']);
              // }else {
              //   this.authenticationService.logout();
              //   this.router.navigate(['/login']);
              // }


              // if its on login page, do not redirect to login page again
              if(this.router.url === '/login') {
                return throwError(err);
              }
              // if the user is not logged in, redirect to login page
              if(!this.authenticationService.currentUser) {
                this.router.navigate(['/login']);
              }

              const parsedToken = this.authenticationService.parseToken;
              // if the token is expired, logout
              const expires = parsedToken.exp;
              const now = Math.floor(Date.now() / 1000);
              // console.log("Token expires at: " + expires);
              // console.log("Current time: " + now);
              if(expires && expires < now) {
                this.authenticationService.logout();
              }else {
                this.router.navigate(['/error-401']);
              }

            } else{
                if(err.status === 404) {
                  // NotFound ENTRY
                }else if(err.status === 422) {
                  // DUPLICATE ENTRY
                }else{
                  console.log(err);
                  this.snackBar.open("Chyba serveru", "OK", {duration: 3000});
                }
            }

            // const error = err.error.message || err.statusText;
            return throwError(err);
        }));

    }
}
